import { useState } from "react";
import { Head } from "@inertiajs/react";
import { Tv } from "lucide-react";
import { Button } from "@/components/ui/button";
import { formatTvCode, normalizeTvCode } from "@/lib/tvDisplay";

/**
 * The code screen at /tv: type the school's 8-character TV display code
 * (from Settings → TV display) to open the display. Built for a TV
 * browser and a remote: one big numeric field, and a plain GET form so
 * it works even where the page's JavaScript doesn't.
 */
export default function TvDisplayNew({ error, form_path }) {
  const [code, setCode] = useState("");

  return (
    <>
      <Head title="TV display" />
      <main className="flex min-h-screen items-center justify-center bg-background px-4 py-12">
        <div className="w-full max-w-xl text-center">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-primary/10 text-primary">
            <Tv className="h-8 w-8" />
          </span>
          <h1 className="mt-6 font-display text-4xl font-semibold text-foreground md:text-5xl">Show your read-a-thon on a TV</h1>
          <p className="mt-3 text-lg text-muted-foreground">
            Enter your school's TV display code, like K7MX-4QPA. School admins find it in PagePledge under TV display.
          </p>

          <form method="get" action={form_path} className="mt-10 space-y-4">
            <label htmlFor="tv-code" className="sr-only">TV display code</label>
            <input
              id="tv-code"
              name="code"
              value={formatTvCode(code)}
              onChange={(e) => setCode(normalizeTvCode(e.target.value))}
              maxLength={9}
              autoCapitalize="characters"
              autoCorrect="off"
              spellCheck={false}
              autoComplete="off"
              autoFocus
              aria-invalid={error ? true : undefined}
              aria-describedby={error ? "tv-code-error" : undefined}
              className="block w-full rounded-xl border border-input bg-card px-6 py-5 text-center font-mono text-5xl font-semibold tracking-[0.25em] text-foreground font-tabular focus:outline-none focus:ring-2 focus:ring-ring"
            />
            {error && (
              <p id="tv-code-error" className="text-base text-destructive">{error}</p>
            )}
            <Button type="submit" size="lg" className="w-full text-lg">
              Show the display
            </Button>
          </form>

          <p className="mt-10 font-display text-2xl font-semibold text-foreground">
            PagePledge<span className="text-primary">.</span>
          </p>
        </div>
      </main>
    </>
  );
}
